import { render } from "./PlayerCard.vue?vue&type=template&id=38eeaeec&scoped=true"
import script from "./PlayerCard.vue?vue&type=script&lang=js"
export * from "./PlayerCard.vue?vue&type=script&lang=js"

import "./PlayerCard.vue?vue&type=style&index=0&id=38eeaeec&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38eeaeec"]])

export default __exports__